<template>
    <div>
        <az-empty-state v-if="!dados" icon="fas fa-clipboard-check" />

        <template v-else>

            <div class="card carde mb-2 w3-animate-opacity" v-for="(mov, inx) in dados" :key="inx">
                <div class="card-body py-2">
                    <div class="row" >
                        <div class="col col-12 col-md-2">
                            #{{ mov.link.model.id_estoque_solicitacao }}
                            <div class="small">
                                {{ $util.getFormatDate(mov.dt_movimentacao) }}
                                {{ mov.dt_movimentacao.substr(11,5) }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-6">
                            <div>
                                {{ mov.item.search }} (#{{ mov.id_estoque_item }})
                                <template v-if="mov.st_lote && mov.st_lote != 'Sem Lote'">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    <span class="small">
                                        Lote: {{ mov.st_lote }}
                                    </span>
                                </template>
                            </div>
                            <div class="small text-muted" v-if="mov.complemento">
                                {{ mov.complemento }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-2">
                            {{ mov.in_quantidade }} 
                            <small class="text-muted">{{ mov.item.st_unidade_estoque }}</small>
                        </div>
                        <div class="col col-12 col-md-2">
                            <input type="checkbox" class="form form-control" v-model="mov.selecionado">
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="false">
                <p>Teste...</p>
                <pre>{{ dados }}</pre>
                <button type="button" class="btn btn-primary" @click="load()">Reload!</button>
            </div>
            
            <nav class="navbar fixed-bottom navbar-light bg-light" id="menu-guias" v-if="dados">
                <div>
                    <button class="btn btn-outline-secondary mr-2" type="button" @click="marcar_todos(true)">
                        <i class="far fa-check-square d-block d-lg-none"></i>
                        <span class="d-none d-lg-block">
                            Marcar Todos
                        </span>
                    </button>
                    <button class="btn btn-outline-secondary mr-2" @click="marcar_todos(false)">
                        <i class="far fa-square d-block d-lg-none"></i>
                        <span class="d-none d-lg-block">
                            Desmarcar Todos
                        </span>
                    </button>
                    <span class="badge badge-dark ml-2">
                        {{ dados.length }}
                    </span>
                </div>
                <div>
                    <div class="progress mt-0 mb-1">
                        <div class="indeterminate" v-if="$store.state.loading"></div>
                        <div class="determinate" v-else></div>
                    </div>

                    <button class="btn btn-success" @click="marcar_todos(false)">
                        Confirmar Recebimento
                    </button>
                </div>
            </nav>
                

        </template>
    </div>
</template>

<script>
//import _ from 'lodash';
//import $ from 'jquery';
//import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data () { 
        return { 
            dados: null, 
        }
    },

    components: { 
        AzEmptyState,
    },

    methods: { 
        load() { 
            this.$util.load(this, { 
                service: 'estoque',
                func: 'confirm_receb', 
                loadTo: res => { 
                    this.dados = res;
                }
            });
        },

        marcar_todos(acao) { 
            this.dados.forEach(item => {
                item.selecionado = acao;
            });
        }
    },

    mounted() { 
        this.load();

        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: 'Confirmar Recebimento', path: "/suprimentos/confirm-receb" }
        ]);
    }
}
</script>